<template>
  <div class="" v-if="permission && permission.version === '5'">
    <div class="page_heading">
      <div class="col-5 module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <span class="head_txt module_type_name institution-title ace_sec_hd">Pre-Curated Institution Management</span>
      </div>
      <div class="col-7 btn_container pagination_sty3">
        <button class="btn btn-primary" aria-label="upload" @click="uploadInstitutionClicked">upload</button>
      </div>
    </div>
    <div class="user-management-section">
      <div class="page_subheading">
        <div class="toolbar-right ui-list-toolbar">
          <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
            <option v-for="option in sizeOptions" v-bind:value="option">
              {{ option }}
            </option>
          </select>
          <div class="btn_container pagination_sty3">
            <button type="button" :disabled="this.firstPage" @click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
            <button type="button" :disabled="this.lastPage" @click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>
          <div class="search-box-container">
            <input type="text" class="input-search" v-model="searchTitle" placeholder="search by name" aria-label="search by name" @keyup.enter="search">
            <button type="button" class="btn btn_srh" @click="search" aria-label="search institutions">
              <span class="ic_srh ic_search" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="table_containers">
        <table v-if="isInstitutionsLoaded" class="table user-management-table">
          <thead class="thead-light">
            <tr>
              <td class="first-column" style="text-align: center !important;">Institution Name</td>
              <td class="second-column" style="text-align: center !important;">External Id</td>
              <td class="action-column">Action</td>
            </tr>
          </thead>
          <tbody v-if="institutions.length > 0">
            <tr v-for="institution in institutions">
              <td class="first-column" style="text-align: center !important;">{{ institution.name }}</td>
              <td class="second-column" style="text-align: center !important;">{{ institution.externalId }}</td>
              <td class="action-column">
                <template>
                  <span class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click="showDeletePreCuratedInstitutionConfirmBox(institution)"></span>
                </template>
              </td>
            </tr>
          </tbody>
          <tbody v-else class="no-result">
            <tr>No Results Found</tr>
          </tbody>
        </table>
      </div>
    </div>
    <div>
      <b-modal class="delete-folder-popup" ref="institutionModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div>
          <span>{{ institutionDeleteMessage }}</span>
        </div>
        <div slot="modal-header" class="popover-header">
          <div class="popup-heading">Please Confirm!</div>
          <button class="btn_close" aria-label="close" @click="hideDeleteConfirmBox">
          <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteInstitutionAndHideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
          <b-button @click="hideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
        </div>
      </b-modal>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
  import '../../../assets/module/css/user/userList.min.css'
  import { mapActions, mapState } from 'vuex'
  
  export default {
    name: 'pre-curated-institution-list',
    data () {
      return {
        pageSize: 10,
        sizeOptions: [ 10, 50, 100 ],
        firstPage: true,
        lastPage: true,
        page: 0,
        totalPages: 0,
        totalElements: 0,
        institutions: [],
        isInstitutionsLoaded: false,
        institutionDeleteMessage: '',
        institutionToBeDeleted: {},
        searchTitle: ''
      }
    },
  
    mounted () {
      this.loadPermission().then(res => {
        this.$refs.loadingModal.show()
        setTimeout(() => {
          this.loadPreCuratedInstitutionList()
        }, 500)
      })
    },
    methods: {
      ...mapActions([
        'searchPreCuratedInstitutions',
        'deletePreCuratedInstitution',
        'loadPermission'
      ]),
      loadPreCuratedInstitutionList () {
        this.searchPreCuratedInstitutions({page: this.page, count: this.pageSize, name: this.searchTitle}).then(result => {
          this.institutions = result.content
          this.page = result.number
          this.firstPage = result.first
          this.lastPage = result.last
          this.totalPages = result.totalPages
          this.totalElements = result.totalElements
          this.isInstitutionsLoaded = true
          this.$refs.loadingModal.hide()
        })
      },
      showDeletePreCuratedInstitutionConfirmBox (institution) {
        this.institutionToBeDeleted = institution
        this.$refs.institutionModal.show()
        this.institutionDeleteMessage = 'Are you sure you would like to delete this pre-curated institution?'
      },
      deleteInstitutionAndHideDeleteConfirmBox () {
        this.$refs.institutionModal.hide()
        this.deletePreCuratedInstitutionClicked()
      },
      deletePreCuratedInstitutionClicked () {
        if (this.institutionToBeDeleted && this.institutionToBeDeleted.uuid) {
          this.deletePreCuratedInstitution(this.institutionToBeDeleted.uuid).then(res => {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Successfully deleted "' + this.institutionToBeDeleted.name + '"'
            })
            this.loadPreCuratedInstitutionList()
          })
        }
      },
      hideDeleteConfirmBox () {
        this.institutionToBeDeleted = {}
        this.$refs.institutionModal.hide()
      },
      uploadInstitutionClicked () {
        return this.$router.push({ name: 'preCuratedInstitutionUpload' })
      },
      resetPage () {
        this.page = 0
        this.loadPreCuratedInstitutionList()
      },
      prev () {
        this.page = this.page - 1
        this.loadPreCuratedInstitutionList()
      },
      next () {
        this.page = this.page + 1
        this.loadPreCuratedInstitutionList()
      },
      search () {
        this.page = 0
        this.firstPage = true
        this.lastPage = true
        this.totalPages = 0
        this.totalElements = 0
        this.loadPreCuratedInstitutionList()
      }
    },
    computed: {
      ...mapState({
        'permission': state => state.user.permission
      }),
  
      createInsitutionButtonEnabled () {
        let permission = this.permission
        let institutionPermission = permission.institutionPermission
        return institutionPermission && institutionPermission.create
      }
    }
  }
</script>
<style scoped>
  .program_guide_icon {
    float:left;
    width:30px;
    font-size:30px;
    color:#34b2ff;
    margin:3px 3px 0 0 !important;
  }
  .program_guide_title {
    color: #34b2ff;
    font-size: 22px;
    font-weight: 400;
    float: left;
    margin-top: 4px;
  }
</style>


// WEBPACK FOOTER //
// src/app/institution/components/PreCuratedInstitutionList.vue